var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1086_16324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.48175V18H9.01354C7.25778 17.9992 5.54061 17.4848 4.07353 16.5202C2.60645 15.5557 1.45354 14.1831 0.756798 12.5715C0.0600601 10.9599 -0.150074 9.17968 0.152279 7.45015C0.454632 5.72061 1.25627 4.11729 2.45844 2.83766C3.66062 1.55802 5.21084 0.657969 6.91815 0.248354C8.62546 -0.161261 10.4153 -0.0625467 12.0672 0.532339C13.7191 1.12722 15.1609 2.1923 16.2151 3.59638C17.2693 5.00045 17.8897 6.68221 18 8.4345V8.48175ZM9.75004 5.25H5.25004V6.75H9.75004V5.25ZM12.75 8.25H5.25004V9.75H12.75V8.25ZM12.75 11.25H5.25004V12.75H12.75V11.25Z",
    fill: "#1C2B48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1086_16324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.68e4cdf3.svg";
export { ForwardRef as ReactComponent };